import { render, staticRenderFns } from "./playlistDetail.vue?vue&type=template&id=68531154&scoped=true"
import script from "./playlistDetail.vue?vue&type=script&lang=js"
export * from "./playlistDetail.vue?vue&type=script&lang=js"
import style0 from "./playlistDetail.vue?vue&type=style&index=0&id=68531154&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68531154",
  null
  
)

export default component.exports